export default function Loading({ size }) {
    return <img alt='' style={{ maxWidth: size + 'px', margin: '0 auto', display: 'flex' }} src={'/img/loading.gif'} />
}

Loading.defaultProps = {
    size: 50,
}
